module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Custom period":"Свой период","days":"Даты","months":"Месяцы","years":"Годы"}}')
  delete Component.options._Ctor
}
